import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tool } from "@app/tool/model/tool.model";
import { Log } from "ng2-logger";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-details-header',
    templateUrl: './details-header.component.html',
    styleUrls: ['./details-header.component.scss']
})
export class DetailsHeaderComponent {
    _logger = Log.create(DetailsHeaderComponent.name);

    @Input() selectedTool: Tool;
    @Input() loading = false;

    @Output() onInvalidateTool = new EventEmitter<any>();
    @Output() onRevalidateTool = new EventEmitter<any>();
    @Output() onRaiseIntervention = new EventEmitter<any>();
    @Output() closeModal = new EventEmitter<any>();

    constructor(private translateService: TranslateService) {
    }

    get validForManufacturingColor() {
        return this.selectedTool && this.selectedTool.isAvailableForManufactoring ? {"good": true} : {"evil": true};
    }

    get notAvailableReason() {
        if (!this.selectedTool) { return ''; }
        switch (this.selectedTool.notAvailableReason) {
            case 0: return this.translateService.instant('admin.tools.details.header.tooltips.toolNotEngraved');
            case 1: return this.translateService.instant('admin.tools.details.header.tooltips.toolHasTicket');
            case 2: return this.translateService.instant('admin.tools.details.header.tooltips.toolIsDeleted');
            case 3: {
                if (this.selectedTool.invalidateComment) {
                    return this.selectedTool.invalidateComment;
                }
                return this.translateService.instant('admin.tools.details.header.tooltips.toolManualInvalidation');
            }
            case 4: return this.translateService.instant('admin.tools.details.header.tooltips.incompleteDocumentation');
            default: return '';
        }
    }

}
